import { FormLabel } from '@chakra-ui/react';

export default function InputLabel({ label }) {
  return <FormLabel fontSize={16}>{label}</FormLabel>;
}
